import PropTypes from 'prop-types';
import React from "react";
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { duration } from 'moment';
import { success } from 'toastr';
import AppInitializer from 'AppInitializer';
import { LowBalanceAlertProvider } from 'context/LowBalanceAlertContext';
import GlobalLowBalanceAlert from 'pages/Dboard/GlobalLowBalanceAlert';


// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const queryClient = new QueryClient({
  defaultOptions:{
    queries:{
      staleTime: 60*1000
    }
  }
})
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false}/>

      <LowBalanceAlertProvider>
        <GlobalLowBalanceAlert />
        <React.Fragment>
          <AppInitializer>
            <Routes>
              <Route>
                {authRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={
                      <NonAuthLayout>
                        {route.component}
                      </NonAuthLayout>
                    }
                    key={idx}
                    exact={true}
                  />
                ))}
              </Route>

              <Route>
                {userRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={
                      <Authmiddleware>
                        {route.component}
                      </Authmiddleware>}
                    key={idx}
                    exact={true}
                  />
                ))}
              </Route>
          </Routes>
          </AppInitializer>
        </React.Fragment>
        <Toaster
          position='top-center'
          gutter={12}
          toastOptions={{
            success:{
              duration:3000,
            },
            error:{
              duration:5000,
            }
          }}
        />
      </LowBalanceAlertProvider>
      
    </QueryClientProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
